// extracted by mini-css-extract-plugin
export default {"row":"ShowRowContent_row__P58Bq","fullWidthDescription":"ShowRowContent_fullWidthDescription__1czvm","tableData":"ShowRowContent_tableData__Q2-78"};